module.exports = __webpack_public_path__ + "img/Trillionaire-6.6a1aca74.gif";